// frontend/src/pages/shop/CreateDelivery.jsx
// ШОПЫН АДМИН - ХҮРГЭЛТ ШИВЭХ (Placeholder)

import { useNavigate } from 'react-router-dom';

const CreateDelivery = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6 lg:p-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <button
            onClick={() => navigate('/shop/deliveries')}
            className="mb-4 flex items-center gap-2 text-gray-600 hover:text-gray-900 transition"
          >
            <span>←</span>
            <span>Буцах</span>
          </button>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
            📦 Хүргэлт шивэх
          </h1>
          <p className="text-gray-600">Шинэ хүргэлт үүсгэх</p>
        </div>

        {/* Placeholder Content */}
        <div className="bg-white rounded-xl shadow-sm p-8 border border-gray-200 text-center">
          <div className="text-6xl mb-4">🚧</div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Тун удахгүй...
          </h2>
          <p className="text-gray-600 mb-6">
            Хүргэлт шивэх функц удахгүй нэмэгдэнэ
          </p>
          <button
            onClick={() => navigate('/shop/deliveries')}
            className="px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition"
          >
            Хүргэлтүүд рүү буцах
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateDelivery